<template>
  <div class="nav-dropdown">
    <div
      class="nav-dropdown__inner container"
      :class="{ 'nav-dropdown__inner--without-categories' : !hasSeveralCategories }"
    >
      <div
        v-if="hasSeveralCategories"
        class="nav-dropdown__categories"
      >
        <button
          v-if="$nuxt.$breakpoints.sMd"
          class="nav-dropdown__return-btn"
          @click="$emit('closeGroupMenu')"
        >
          {{ groupMenuTitle }}
          <svg-right-arrow-icon></svg-right-arrow-icon>
        </button>

        <div class="nav-dropdown__categories-wrapper">
          <ul class="nav-dropdown__categories-list">
            <li
              v-for="category in submenu.categories"
              :key="category.primaryKey"
              class="nav-dropdown__categories-item"
            >
              <button
                class="nav-dropdown__categories-link"
                :class="{ 'nav-dropdown__categories-link--active' : selectedCategory === category.primaryKey }"
                @click="openedCategoryMenu(category.primaryKey)"
              >
                {{ category.name }}
                <svg-right-arrow-icon v-if="$nuxt.$breakpoints.sMd"></svg-right-arrow-icon>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="nav-dropdown__body">
        <div
          v-for="category in submenu.categories"
          :key="category.primaryKey"
          class="nav-dropdown__body-wrapper"
          :class="{ 'nav-dropdown__body-wrapper--active' : selectedCategory === category.primaryKey }"
        >
          <div class="nav-dropdown__body-inner">
            <button
              v-if="$nuxt.$breakpoints.sMd && !hasSeveralCategories"
              class="nav-dropdown__return-btn"
              @click="$emit('closeGroupMenu')"
            >
              {{ groupMenuTitle }}
              <svg-right-arrow-icon></svg-right-arrow-icon>
            </button>
            <button
              v-if="$nuxt.$breakpoints.sMd && hasSeveralCategories"
              class="nav-dropdown__return-btn"
              @click="selectedCategory = null"
            >
              {{ category.name }}
              <svg-right-arrow-icon></svg-right-arrow-icon>
            </button>

            <div
              v-if="category.links.items.length > 0"
              class="nav-dropdown__links"
              :class="categoryLinksModifier(category)"
            >
              <menu-link
                v-for="(link, i) in category.links.items"
                :key="i"
                :item="link"
                @closeMenu="$emit('closeMenu')"
              ></menu-link>
            </div>
            <div
              v-if="category.widgets.items.length > 0"
              class="nav-dropdown__widgets"
              :class="categoryWidgetsModifier(category)"
            >
              <div
                v-if="category.widgets.items.length > 1 && $nuxt.$breakpoints.sLg"
                :class="`nav-dropdown__widgets-slider nav-dropdown__widgets-slider-${category.primaryKey}`"
              >
                <swiper :options="setSwiperOptions(category.primaryKey)">
                  <swiper-slide
                    v-for="widget in category.widgets.items"
                    :key="widget.primaryKey"
                  >
                    <contacts-widget
                      v-if="widget.componentName === 'contacts'"
                      :key="widget.primaryKey"
                      :external-type-of-link="widget.externalTypeOfLink"
                      :url="widget.url"
                      @closeMenu="$emit('closeMenu')"
                    ></contacts-widget>
                    <menu-widget
                      v-if="widget.componentName !== 'contacts'"
                      :key="widget.primaryKey"
                      :title="widget.title"
                      :external-type-of-link="widget.externalTypeOfLink"
                      :url="widget.url"
                      @closeMenu="$emit('closeMenu')"
                    >
                      <component
                        :is="widget.componentName"
                        :mode="widget.primaryKey"
                        @closeMenu="$emit('closeMenu')"
                      ></component>
                    </menu-widget>
                  </swiper-slide>
                </swiper>
                <div class="nav-dropdown__widgets-slider-pagination swiper-pagination"></div>
              </div>

              <template
                v-for="widget in category.widgets.items"
                v-else
              >
                <contacts-widget
                  v-if="widget.componentName === 'contacts'"
                  :key="widget.primaryKey"
                  :external-type-of-link="widget.externalTypeOfLink"
                  :url="widget.url"
                  @closeMenu="$emit('closeMenu')"
                ></contacts-widget>
                <menu-widget
                  v-if="widget.componentName !== 'contacts'"
                  :key="widget.primaryKey"
                  :title="widget.title"
                  :external-type-of-link="widget.externalTypeOfLink"
                  :url="widget.url"
                  @closeMenu="$emit('closeMenu')"
                >
                  <component
                    :is="widget.componentName"
                    :mode="widget.primaryKey"
                    @closeMenu="$emit('closeMenu')"
                  ></component>
                </menu-widget>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

import SvgRightArrowIcon from '~/assets/icons/header/dropdown-menu/right-arrow.svg'
import MenuWidget from '~/components/menu/MenuWidget'
import ContactsWidget from '~/components/menu/widgets/ContactsWidget'
import GithubWidget from '~/components/menu/widgets/GithubWidget'
import BlogWidget from '~/components/menu/widgets/BlogWidget'
import Vacancies from '~/components/menu/widgets/Vacancies'
import MeetUpWidget from '~/components/menu/widgets/MeetUpWidget'
import MaterialsWidget from '~/components/menu/widgets/MaterialsWidget'
import InvestorsWidget from '~/components/menu/widgets/InvestorsWidget'
import SuccessStoryWidget from '~/components/menu/widgets/SuccessStoryWidget'
import MenuLink from '~/components/menu/views/MenuLink'

export default {
  name: 'SubMenu',
  components: {
    Swiper,
    SwiperSlide,

    SvgRightArrowIcon,
    MenuWidget,
    ContactsWidget,
    GithubWidget,
    BlogWidget,
    Vacancies,
    MeetUpWidget,
    MaterialsWidget,
    InvestorsWidget,
    SuccessStoryWidget,
    MenuLink
  },
  props: {
    submenu: {
      type: Object,
      default: () => {}
    },
    groupMenuTitle: {
      type: String,
      default: ''
    },
    isNavOpened: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDropDownActive: false,
      selectedCategory: null
    }
  },
  computed: {
    presetSelectedCategory: {
      get() {
        if (this.$nuxt.$breakpoints.lLg || this.$nuxt.$breakpoints.sLg && !this.hasSeveralCategories)
          return this.selectedCategory = this.submenu.categories[0].primaryKey

        return this.selectedCategory = null
      },
      set(newValue) {
        return this.selectedCategory = newValue
      }
    },
    hasSeveralCategories() {
      return this.submenu.categories.length > 1
    }
  },
  watch: {
    isNavOpened() {
      if (this.isNavOpened === false && this.$nuxt.$breakpoints.sMd) {
        if (this.hasSeveralCategories) {
          this.selectedCategory = null
        } else {
          this.selectedCategory = this.submenu.categories[0].primaryKey
        }
      }
    },
    presetSelectedCategory(value) {
      return this.selectedCategory = value
    }
  },
  methods: {
    setSwiperOptions(key) {
      return {
        grabCursor: true,
        loop: true,
        autoHeight: false,
        spaceBetween: 40,
        pagination: {
          // eslint-disable-next-line id-blacklist
          el: `.nav-dropdown__widgets-slider-${key} .swiper-pagination`,
          clickable: true
        }
      }
    },
    openedCategoryMenu(key) {
      this.selectedCategory = key
    },
    categoryLinksModifier(category) {
      if (this.$nuxt.$breakpoints.xl) {
        return category.links.size
          ? `nav-dropdown__links--${category.links.size}`
          : ''
      } else if (this.$nuxt.$breakpoints.lg && !category.widgets.items.length) {
        return 'nav-dropdown__links--wide'
      } else {
        return ''
      }
    },
    categoryWidgetsModifier(category) {
      if (this.$nuxt.$breakpoints.xl) {
        return [
          category.widgets.size
            ? `nav-dropdown__widgets--${category.widgets.size}`
            : '',
          category.widgets.items.length > 1
            ? 'nav-dropdown__widgets--multiple'
            : 'nav-dropdown__widgets--alone'
        ]
      }

      return ''
    }
  }
}
</script>

<style lang="scss">
.nav-dropdown {
  overflow: hidden;
}

.nav-dropdown__inner {
  display: grid;
  grid-template-areas: 'categories dropdown-body';
  grid-template-columns: 3fr 9fr;
  grid-column-gap: 16px;

  @media (max-width: $breakpoint-lg) {
    display: block;
  }

  &--without-categories {
    grid-template-areas: '. dropdown-body';
    grid-template-columns: 2fr 10fr;

    @media (max-width: $breakpoint-lg) {
      grid-template-areas: 'dropdown-body';
      grid-template-columns: 1fr;
    }
  }
}

.nav-dropdown__categories {
  grid-area: categories;
  position: relative;
  height: 364px;

  @media (max-width: $breakpoint-lg) {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: auto;
    padding: 0 10px;
  }

  &:before {
    content: '';
    z-index: -1;
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 100vw;
    height: 100%;
    //TODO
    background-color: $gray50;

    @media (max-width: $breakpoint-lg) {
      display: none;
    }
  }
}

.nav-dropdown__categories-wrapper {
  height: 100%;
}

.nav-dropdown__categories-list {
  max-height: calc(100% - 24px);
  padding: 16px 0;
  list-style: none;
  overflow: auto;

  @media (max-width: $breakpoint-lg) {
    height: calc(100vh - 164px);
    max-height: 100%;
    margin: 0 -10px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }

  @media (max-width: $breakpoint-sm) {
    height: calc(100vh - 204px);
  }
}

.nav-dropdown__categories-item {
  position: relative;
  padding: 8px 0;

  @media (max-width: $breakpoint-lg) {
    padding: 0;

    &:last-child {
      margin-bottom: 32px;
    }
  }

  &:first-child:before {
    top: 8px;
    border-top-left-radius: 1px;
    border-top-right-radius: 1px;
  }

  &:last-child:before {
    bottom: 8px;
    border-bottom-left-radius: 1px;
    border-bottom-right-radius: 1px;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 2px;

    background-color: $primary15;

    @media (max-width: $breakpoint-lg) {
      display: none;
    }
  }
}

.nav-dropdown__categories-link {
  position: relative;
  padding: 0 16px;
  border: 0;
  text-align: left;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  transition: color 0.2s;

  @media (max-width: $breakpoint-lg) {
    width: 100%;
    padding: 16px 42px 16px 10px;
    border-bottom: 1px solid $primary10;
    text-align: left;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 2px;
    height: 1.5em;
    border-radius: 1px;
    opacity: 0;
    visibility: hidden;
    background-color: $secondary;
    transition: 0.2s;

    @media (max-width: $breakpoint-lg) {
      display: none;
    }
  }

  &:hover {
    color: $secondary;
  }

  svg {
    display: none;

    @media (max-width: $breakpoint-lg) {
      position: absolute;
      top: 1.25em;
      right: 10px;
      display: block;
      width: 16px;
      height: 16px;
      transition: 0.2s ease-in-out;
      pointer-events: none;
    }
  }

  &--active {
    &:before {
      opacity: 1;
      visibility: visible;
    }
  }
}

.nav-dropdown__body {
  grid-area: dropdown-body;
  position: relative;
  height: 364px;

  @media (max-width: $breakpoint-lg) {
    position: fixed;
    top: 0;
    right: 0;
    left: 100%;
    width: 100%;
    height: calc(100vh - 49px);

    .nav-dropdown__inner--without-categories & {
      left: 0;
    }
  }
}

.nav-dropdown__body-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: calc(100% + 20px);
  //height: 100%;
  height: auto;
  margin-right: -20px;
  padding-right: 20px;
  opacity: 0;
  visibility: hidden;
  overflow: auto;
  transition: 0.2s;

  @media (max-width: $breakpoint-lg) {
    position: fixed;
    transform: translateX(100%);
    width: 100%;
    margin-right: 0;
    padding-right: 0;
    overflow: visible;
  }

  &--active {
    opacity: 1;
    visibility: visible;
    background-color: #FFF;

    @media (max-width: $breakpoint-lg) {
      transform: translateX(0);

      .nav-dropdown__inner--without-categories & {
        transform: none;
      }
    }
  }
}

.nav-dropdown__body-inner {
  display: grid;
  grid-template-areas: 'links widgets';
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 24px;
  align-items: start;

  @media (max-width: $breakpoint-xl) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: $breakpoint-lg) {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    padding: 0 10px;
  }
}

.nav-dropdown__return-btn {
  display: none;

  @media (max-width: $breakpoint-lg) {
    grid-area: return-btn;
    position: relative;
    display: block;
    width: calc(100% + 20px);
    margin: 0 -10px;
    padding: 16px;
    padding-left: 42px;
    border: 0;
    border-bottom: 1px solid $primary10;
    outline: none;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: $gray50;

    svg {
      position: absolute;
      top: 50%;
      left: 10px;
      transform: translateY(-50%) rotate(-180deg);
      display: block;
      width: 16px;
      height: 16px;
      transition: 0.2s ease-in-out;
      pointer-events: none;
    }
  }
}

.nav-dropdown__links {
  grid-area: links;
  display: grid;
  grid-template-rows: repeat(30, auto);
  grid-column-gap: 40px;
  padding: 12px 0;

  @media (max-width: $breakpoint-xl) {
    grid-column-gap: 16px;
  }

  @media (max-width: $breakpoint-lg) {
    width: calc(100% + 20px);
    height: calc(100vh - 164px);
    max-height: 100%;
    margin: 0 -10px;
    padding-bottom: 92px;
    overflow: hidden;
    overflow-y: auto;

    @media (max-width: $breakpoint-md) {
      padding-bottom: 50px;
    }
  }

  &--one-third {
    grid-column: 1 / 2;
    grid-template-columns: 1fr;
  }

  &--two-thirds {
    grid-column: 1 / 3;
    grid-template-columns: repeat(2, 1fr);
  }

  &--wide {
    grid-column: 1 / 4;
    grid-template-columns: repeat(3, 1fr);

    @media (max-width: $breakpoint-xl) {
      grid-column: 1 / 3;
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

.nav-dropdown__widgets {
  grid-area: widgets;
  display: grid;
  grid-gap: 16px;
  padding: 12px 0;

  @media (max-width: $breakpoint-lg) {
    display: none;
  }

  &--one-third {
    grid-column: 3 / 4;
    grid-template-columns: 1fr;
  }

  &--two-thirds {
    grid-column: 2 / 4;
  }

  &--wide {
    grid-column: 1 / 4;
    grid-template-columns: repeat(3, 1fr);
  }

  &--multiple {
    grid-template-columns: repeat(2, 1fr);
  }
}

.nav-dropdown__widgets-slider {
  position: relative;
  width: calc(100% + 24px);
  margin: 0 -12px;
  padding-bottom: 16px;
  overflow: hidden;

  .swiper-container {
    padding: 0 12px;
  }

  .swiper-slide {
    display: flex;
    height: auto;
  }
}

.nav-dropdown__widgets-slider-pagination {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  .swiper-pagination-bullet {
    background: $gray;
    opacity: 1;
    outline: none;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }

  .swiper-pagination-bullet-active {
    background: $primary30;
    opacity: 1;
  }
}
</style>